import React, { Component } from 'react';
import { Link } from 'react-router';

export default class MenuItem extends Component {

    componentDidMount() {
        // console.log(this.props);
    }

    render () {
        return (
            // eslint-disable-next-line
            <li className={this.props.index == 0 ? 'active' : ''}>
                <Link to={this.props.link} data-toggle="tab">{this.props.label}</Link>
            </li>
        )
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/management/settings/MenuItem.js
 **/